<article class="bg-blue-gradient w-100 px-4 py-md-4">
  <h3 class="text-white">Información asesor</h3>
  <hr />

  <form [formGroup]="bayportInfoForm" class="form">
    <h5 class="labelS bg-blue-gradient w-100 px-2 py-md-2">Datos asesor</h5>

    <!-- Tipo de ejecutivo & Código ejecutivo -->
    <div class="row row-spacing">
      <div class="col-md-3 labelL">Tipo de ejecutivo</div>
      <div class="col-md-3 datoB">
        <span class="text-white">{{ tipoEjecDes | capitalize }}</span>
      </div>

      <div class="col-md-3 labelL">Código ejecutivo</div>
      <div class="col-md-3 datoB">
        <span class="text-white">{{ codigoAsesor }}</span>
      </div>
    </div>

    <!-- Estado & Fecha de creación -->
    <div class="row row-spacing">
      <div class="col-md-3 labelL">Estado</div>
      <div
        class="col-md-3 d-flex justify-content-end align-items-center"
        style="gap: 6px"
      >
        <img
          src="assets/icons/Validation.svg"
          width="16"
          height="16"
          alt="validación"
        />
        <span class="text-white" style="font-size: 14px">{{
          estado | capitalize
        }}</span>
      </div>

      <div class="col-md-3 labelL">Fecha de creación</div>
      <div class="col-md-3 datoB">
        <span class="text-white">{{ fechaCrea | date : "dd/MM/yyyy" }}</span>
      </div>
    </div>

    <!-- Regional & Sucursal -->
    <div class="row row-spacing">
      <div class="col-md-3 labelL">Regional</div>
      <div class="col-md-3 datoB">
        <span class="text-white">{{ regionalNombre | capitalize }}</span>
      </div>

      <div class="col-md-3 labelL">Sucursal</div>
      <div class="col-md-3 datoB">
        <span class="text-white">{{ sucursalNombre | capitalize }}</span>
      </div>
    </div>

    <!-- Canal & Canal de venta -->
    <div class="row row-spacing">
      <div class="col-md-3 labelL">Tipo de canal</div>
      <div class="col-md-3 datoB">
        <span class="text-white">{{ canalNombre | capitalize }}</span>
      </div>

      <div class="col-md-3 labelL">Canal de venta</div>
      <div class="col-md-3 datoB">
        <span class="text-white">{{ canalVentaNombre | capitalize }}</span>
      </div>
    </div>

    <!-- Nombre a quien refiere -->
    <div class="row row-spacing">
      <div class="col-md-3 labelL">Nombre a quien refiere</div>
      <div class="col-md-3 datoB">
        <span class="text-white">{{ nombreRefiere | titlecase }}</span>
      </div>
    </div>

    <hr />
    <h5 class="labelS bg-blue-gradient w-100 px-2 py-md-2">
      Datos de contacto
    </h5>

    <!-- Correo 1 & Correo 2 -->
    <div class="row mt-3">
      <div class="col-md-6 form-field">
        <label for="bayportEmail" class="form-label"
          >Correo electrónico 1</label
        >
        <input
          id="bayportEmail"
          type="email"
          class="form-control"
          formControlName="correo"
          placeholder="*Correo electrónico"
          autocomplete="off"
        />
      </div>
      <div class="col-md-6 form-field">
        <label for="correo2" class="form-label">Correo electrónico 2</label>
        <input
          id="correo2"
          type="email"
          class="form-control"
          formControlName="correo2"
          placeholder="*Correo electrónico"
          autocomplete="off"
        />
      </div>
    </div>

    <!-- Celular -->
    <div class="row mt-3">
      <div class="col-md-6 form-field">
        <label for="celular" class="form-label">Celular</label>
        <input
          id="celular"
          type="tel"
          inputmode="numeric"
          class="form-control"
          formControlName="celular"
          placeholder="*Celular"
          autocomplete="off"
        />
      </div>
    </div>
    <!-- Alerta -->
    <div class="d-flex justify-content-center" *ngIf="showAdvertencia">
      <app-advertencias [color]="colorAdvertencia">{{
        textoAdvertencia
      }}</app-advertencias>
    </div>
    <!-- Botón Guardar -->
    <div class="d-flex justify-content-center">
      <button-look-feel
        color="secondary"
        (clicked)="onSave()"
        [loading]="loadingAdvertencia"
        [disabled]="showAdvertencia || !bayportInfoForm.valid"
      >
        Guardar
      </button-look-feel>
    </div>
  </form>
</article>
